/**
 * MY Register Detail plug-in entry-point.
 *   App 부팅 시 한 번 import 되어 side-effect 로 각 task code 의
 *   register-detail field map 을 shared registry 에 등록.
 *
 * 등록 위치 — `my/preset/index.ts` 에서:
 *   import './register';
 */

import './changeOfficer';
import './resignationOfDirector';
import './resignationOfSecretary';
import './appointmentOfSecretary';
import './changeAddress';
import './changeBusinessAddress';
import './updateBusinessAddress';
import './allotmentShares';
import './allotmentOtc';
import './allotmentBonus';
import './boNotices';
import './boAppendix';
import './declarationNonBo';
import './extensionOfTime';
import './exemptPrivateCompany';
import './shareCertificate';
import './transferShares';

// B15 (Nationality) baseCode 캐시 — Register Detail 에서 동기 lookup 가능하도록 사전 로드.
//   side-effect import 로 모듈 평가 시점에 백그라운드 fetch 시작 (await 없음 — non-blocking).
import { prefetchB15Cache } from '../../../shared/preset/lookups/b15NationalityCache';
void prefetchB15Cache();
